export default __webpack_public_path__ + "static/media/Ficho-rojo.e4ef14c5.png";